<template>
	<Row class="bg-[#091538]">
		<Container>
			<h2
				id="scanner-pitch-title"
				class="stocks-watching-title text-white lg:mb-8"
			>
				These Are the Stocks I'm Watching TODAY!
			</h2>

			<div class="stocks-watching-header">
				<h3 class="text-3xl text-white font-normal text-left hidden lg:block">
					News
				</h3>

				<LinkWithArrow
					text-color=""
					label="All Breaking News"
					link="/news/"
					class="!hover:text-white/[.75] text-white"
				/>
			</div>
			<div class="flex flex-col lg:flex-row gap-8 mb-8 lg:mb-14 lg:gap-4">
				<MarketsHeroBanner
					id="featured"
					:news_list="newsList.slice(0, 4)"
				/>

				<TopGainerStocks
					id="top-gainers-header"
					class="lg:max-w-[340px] w-full"
					:alternative="true"
				/>
			</div>
			<MarketsCoverageRow
				id="coverage"
				alternative="true"
				:news="newsList.slice(4, 10)"
			/>
		</Container>
	</Row>
</template>

<script setup>
defineProps({
	newsList: {
		type: Array,
		required: true,
		default: () => []
	}
});
</script>

<style lang="scss" scoped>
.stocks-watching-title {
	font-size: 32px;
	font-weight: 900;
	line-height: 1.1;

	@media (min-width: 768px) {
		font-size: 48px;
	}

	@media (min-width: 1024px) {
		font-size: 64px;
	}
}

.stocks-watching-header {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	margin-bottom: 1rem;

	@media (min-width: 1024px) {
		flex-direction: row;
		margin-bottom: 2rem;
		align-items: end;
	}
}
</style>
